// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1373":"23fbc84c","2775":"948984cf","3040":"43e9a5fe","7350":"36d9e990","7396":"43e9a5fe"}[chunkId] + ".chunk.css";
};